export const COLUMN_HEADINGS = ['Email', 'First Name', 'Last Name', 'Ticket Type', 'Quantity', 'Options'];
export const COLUMN_MIN_WIDTH = [200, 200, 200, 200, 120, 120];

export const GRID_COLUMNS = `repeat(${COLUMN_HEADINGS.length}, 1fr)`;
export const GRID_COLUMNS_MIN = `repeat(${COLUMN_HEADINGS.length}, 1fr)`;
